var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPulpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_599",
    "data-name": "Group 599",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.466,
    height: 59.617,
    viewBox: "0 0 46.466 59.617",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M17.547,88.59q0,6.594,0,13.188a3.543,3.543,0,0,1-.359,1.633,1.982,1.982,0,0,1-2.127,1.346,24.52,24.52,0,0,0-2.857-.016,1.07,1.07,0,0,1-.83-.34,3.538,3.538,0,0,1-1.082-2.448,1.9,1.9,0,0,1,1.065-1.867,1.157,1.157,0,0,0,.693-.74.839.839,0,0,0-1.079-.961,3.37,3.37,0,0,0-2.3,2.819c-.047.521-.2.693-.752.628A4.5,4.5,0,0,1,3.96,97.918a4.569,4.569,0,0,1,2.7-4.782c.3-.131.625-.214.931-.335a.84.84,0,0,0,.637-.98c-.1-.508-.471-.669-.956-.655a3.166,3.166,0,0,0-1.433.448,7.877,7.877,0,0,0-2.2,1.713.536.536,0,0,1-.754.138A5.517,5.517,0,0,1,.11,87.445a5.3,5.3,0,0,1,4.72-4.338A3.473,3.473,0,0,1,7.579,84.3a.882.882,0,0,0,1.252.1.914.914,0,0,0-.02-1.264,3.071,3.071,0,0,0-.28-.3A4.983,4.983,0,0,0,4.887,81.4c-.632.021-.865-.222-.952-.8A4.581,4.581,0,0,1,6.21,75.911a4.368,4.368,0,0,1,5.032.279,5.426,5.426,0,0,1,.949,1.1c.243.311.513.6.978.469a.814.814,0,0,0,.518-1.319,5.609,5.609,0,0,0-2.556-2.312c-.491-.233-.479-.433-.22-.824a3.591,3.591,0,0,1,4.055-1.431,3.471,3.471,0,0,1,2.58,3.356q.009,6.682,0,13.363",
    transform: "translate(0 -60.532)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M137.656,83.225q0-7.729,0-15.459a5.6,5.6,0,0,1,.038-.814,1.192,1.192,0,0,1,1.432-1.176,13.517,13.517,0,0,1,7.682,3.045,14.4,14.4,0,0,1,5.364,9.884,13.977,13.977,0,0,1-4.927,12.6,12.533,12.533,0,0,0-4.161,7.8c-.068.474-.236.625-.7.616-1.225-.022-2.45-.007-3.675-.007-1.058,0-1.058,0-1.058-1.033q0-7.729,0-15.459m11.773-3.582h-.023a5.166,5.166,0,0,0,0-.7,11.9,11.9,0,0,0-4.583-8.038,10.245,10.245,0,0,0-2.9-1.593c-.673-.239-1.114-.075-1.319.443-.2.5.046.893.728,1.175a9.9,9.9,0,0,1,6.232,7.515,11.859,11.859,0,0,1,.2,1.851.769.769,0,0,0,.848.776.756.756,0,0,0,.824-.789c.015-.213,0-.427,0-.641",
    transform: "translate(-116.187 -55.512)",
    fill: "#fb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M64.226,297.114h-9.4c-1.127,0-1.642-.537-1.611-1.677a2.473,2.473,0,0,1,2.266-2.455,11.334,11.334,0,0,1,1.163-.067q7.587-.007,15.174,0a10.833,10.833,0,0,1,1.221.074,2.448,2.448,0,0,1,1.971,3.39,1.046,1.046,0,0,1-1.1.746c-3.229-.024-6.459-.011-9.688-.011",
    transform: "translate(-44.918 -247.228)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M64.324,329.258c3.228,0,6.457.016,9.685-.014a1.036,1.036,0,0,1,1.118.79,2.5,2.5,0,0,1-1.9,3.278,5.237,5.237,0,0,1-.869.077q-8.051.007-16.1,0a2.732,2.732,0,0,1-2.312-.874A2.493,2.493,0,0,1,53.5,329.9a.9.9,0,0,1,.967-.653c3.287.02,6.573.01,9.86.01",
    transform: "translate(-44.994 -277.894)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M88.306,367.9c-1.225,0-2.45.007-3.675,0a3.047,3.047,0,0,1-2.827-2.064c-.123-.375-.1-.584.378-.583q6.125.013,12.251,0c.39,0,.464.155.374.5A3.08,3.08,0,0,1,92.1,367.9l-.117,0H88.306",
    transform: "translate(-68.992 -308.286)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M213.474,51.159a.885.885,0,0,1-.876-.491.9.9,0,0,1,.047-1.041,2.982,2.982,0,0,1,.31-.347q1.936-1.94,3.876-3.877a3.214,3.214,0,0,1,.3-.277,1.012,1.012,0,0,1,1.375.052.931.931,0,0,1,.014,1.362c-.579.629-1.2,1.221-1.8,1.826-.8.8-1.6,1.593-2.391,2.392a1.066,1.066,0,0,1-.852.4",
    transform: "translate(-179.32 -37.884)",
    fill: "#fb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M250.082,154.849c-.972,0-1.943.008-2.915,0-.713-.008-1.114-.372-1.125-.985a.966.966,0,0,1,1.033-1.028q3-.044,6,0a1.01,1.01,0,1,1-.082,2.011c-.971.01-1.943,0-2.915,0",
    transform: "translate(-207.668 -128.978)",
    fill: "#fb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M213.4,233.63a1.2,1.2,0,0,1,.809.39c1.388,1.387,2.781,2.77,4.161,4.165a.938.938,0,0,1,.067,1.48.925.925,0,0,1-1.438-.059q-2.136-2.109-4.245-4.246a.891.891,0,0,1-.229-1.111,1.109,1.109,0,0,1,.876-.62",
    transform: "translate(-179.285 -197.193)",
    fill: "#fb0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulpIcon);
export default __webpack_public_path__ + "static/media/pulp_icon.04af12d144693fe496decc8b6a3a8ebb.svg";
export { ForwardRef as ReactComponent };